module.exports = __webpack_public_path__ + "static/media/album-collection.b27a4a04.svg";